import { useState } from 'react'
import { FieldGroup, FormCard, SubmitButton } from '../../reusable'

import { FormPartInterface } from '../../../interfaces'

export const OpenBankingStep = (props: FormPartInterface) => {
    const { isActive } = props

    const [currentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)

    const getCurrentStep = () => {
        return isActive == 'openBanking' ? (
            <FieldGroup title="Thank You">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                    <div style={{ marginBottom: '50px', textAlign: 'center' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}>Thank you!</h2>
                        <p
                            style={{
                                textAlign: 'center',
                                lineHeight: '1.8',
                                marginTop: '0',
                                marginBottom: '40px',
                                letterSpacing: '1px',
                                fontSize: '15px',
                                color: 'grey',
                            }}
                        >
                            Your form has been received. We're reviewing your details and will be in touch shortly.
                        </p>
                        <SubmitButton
                            onClick={() => { window.location.href = '/' }}
                            text="Submit a new claim"
                            btnType="primary"
                        />
                    </div>
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
